import { render, staticRenderFns } from "./WalletContentHeader.vue?vue&type=template&id=741e8f06&"
import script from "./WalletContentHeader.vue?vue&type=script&lang=js&"
export * from "./WalletContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports